import './HeroStyles.css';

import { useHeroController } from './HeroController';

export const HeroView = () => {
  const {
    slides,
    currentSlide,
    dragOffset,
    isDragging,
    onStart,
    onMove,
    onEnd,
    nextSlide,
    prevSlide,
  } = useHeroController();

  const sliderStyle = {
    transform: `translateX(calc(-${currentSlide * 100}% + ${dragOffset}px))`,
    transition: isDragging
      ? 'none'
      : 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
  };

  return (
    <section className="hero-section">
      <div
        className="hero-viewport"
        onMouseDown={onStart}
        onMouseMove={onMove}
        onMouseUp={onEnd}
        onMouseLeave={onEnd}
        onTouchStart={onStart}
        onTouchMove={onMove}
        onTouchEnd={onEnd}
      >
        {/* Decorative SVG Elements */}
        <svg
          className="hero-decoration hero-decoration-left"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100,20 Q150,50 150,100 Q150,150 100,180 Q50,150 50,100 Q50,50 100,20"
            fill="none"
            stroke="rgba(255,105,180,0.1)"
            strokeWidth="2"
          />
          <circle
            cx="100"
            cy="100"
            r="30"
            fill="none"
            stroke="rgba(255,105,180,0.15)"
            strokeWidth="1.5"
          />
        </svg>

        <svg
          className="hero-decoration hero-decoration-right"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20,50 Q60,40 100,60 Q140,80 130,140 Q100,160 50,140 Q20,120 20,50"
            fill="none"
            stroke="rgba(255,105,180,0.1)"
            strokeWidth="2"
          />
          <rect
            x="40"
            y="80"
            width="50"
            height="50"
            fill="none"
            stroke="rgba(255,105,180,0.15)"
            strokeWidth="1.5"
          />
        </svg>

        <div className="hero-slider" style={sliderStyle}>
          {slides.map((slide, index) => (
            <div key={slide.id} className="hero-slide">
              <img
                src={slide.image}
                alt="Hero Slide"
                className="hero-slide-image"
                loading={index === 0 ? 'eager' : 'lazy'}
                fetchpriority={index === 0 ? 'high' : 'auto'}
              />
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <button
          className="hero-button hero-button-prev"
          onClick={prevSlide}
          aria-label="Slide anterior"
          type="button"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <button
          className="hero-button hero-button-next"
          onClick={nextSlide}
          aria-label="Próximo slide"
          type="button"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>

        {/* Enhanced Dots Navigation */}
        <div className="hero-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => {
                while (currentSlide < index) nextSlide();
                while (currentSlide > index) prevSlide();
              }}
              aria-label={`Ir para slide ${index + 1}`}
              aria-current={index === currentSlide}
              type="button"
            />
          ))}
        </div>

        {/* Slide Counter */}
        <div className="hero-counter">
          <span className="counter-current">
            {String(currentSlide + 1).padStart(2, '0')}
          </span>
          <span className="counter-separator">/</span>
          <span className="counter-total">
            {String(slides.length).padStart(2, '0')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default HeroView;
